export default "__VITE_ASSET__5b2a0c49__"